export default __webpack_public_path__ + "static/notification-d5d8ec2285a606e44f861e2ca919e68a.wav";